import classnames from 'classnames/bind'
import { ComponentProps } from 'react'
import { InferReturn, PropsWithClassName } from '~/@types/generic'

import FilteredShopifyGrid from '~/components/PageWithFilters/ShopifyFilteredGrid'
import Filters from '~/components/UI/Filters'

import { SearchAndDiscoveryProvider } from '~/providers/SearchAndDiscoveryProvider'

import { serializeCategoryPage } from '~/data/category-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export function PageWithFilters({
  className,
  ...primaryPageData
}: PropsWithClassName<
  Omit<
    ComponentProps<typeof PageWithFiltersWrapper>,
    'facets' | 'defaultFilters' | 'shopifyForceFirstPage'
  >
>) {
  return (
    <section className={cx(className, css.PageWithFilters)}>
      <Filters className={css.filters} />
      {/* Setting the content */}
      <FilteredShopifyGrid primaryPageData={primaryPageData} />
    </section>
  )
}

export default function PageWithFiltersWrapper({
  defaultFilters,
  facets,
  ...props
}: Omit<
  InferReturn<typeof serializeCategoryPage>,
  'categoryHero' | 'isHeroTitleOnly' | 'slices' | 'isNavigationHidden'
>) {
  return (
    <SearchAndDiscoveryProvider defaultFilters={defaultFilters} facets={facets}>
      <PageWithFilters {...props} />
    </SearchAndDiscoveryProvider>
  )
}
